import React from "react";
import { useParams } from "react-router-dom";

import { TYPE_FORM } from "../constants";

import ExpensesAddFormClassic from "./ExpensesAddFormClassic";
import ExpensesAddFormKmCh from "./ExpensesAddFormKmCh";
import ExpensesAddFormKmFr from "./ExpensesAddFormKmFr";

const ExpensesAddForm = () => {
    const {
        id_category: param_id_category,
        id_expense: param_id_expense,
        type_form: param_type_form,
    } = useParams();

    switch (param_type_form) {
        case TYPE_FORM.classic:
            return <ExpensesAddFormClassic />;
        case TYPE_FORM.km_fr:
            return <ExpensesAddFormKmFr />;
        case TYPE_FORM.km_ch:
            return <ExpensesAddFormKmCh />;
        default:
            return <ExpensesAddFormClassic />;
    }
};

export default ExpensesAddForm;
